
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {MsalService} from '@azure/msal-angular';
import { UserService } from 'src/framework/services/userservice';

@Injectable({ providedIn: 'root' })
export class SessionManagementGuard implements CanActivate {

    public sessionReq = {
        userEmail : null,
        sessionId : null
      }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private msalSvc: MsalService,
    private userService: UserService,
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let ret = true;
    if (this.msalSvc.instance.getActiveAccount() != null) {
     
        this.sessionReq = JSON.parse(sessionStorage.getItem('CurrentSession'));
        if(this.sessionReq != null) {
            this.userService.getSessionInfo(this.sessionReq.sessionId).subscribe((response: any) =>{

                if(!response.isActive){

                   ret = false;
                   localStorage.clear();
                   sessionStorage.clear();
                   this.msalSvc.logout();
                   this.router.navigate["/home"];
                }

            } );
        }
    } 
    return ret;
  }

}
